import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=6e491b75&scoped=true&"
import script from "./Relatorio.vue?vue&type=script&lang=js&"
export * from "./Relatorio.vue?vue&type=script&lang=js&"
import style0 from "./Relatorio.vue?vue&type=style&index=0&id=6e491b75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e491b75",
  null
  
)

export default component.exports